(function($) {

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    
    $(document).ready( function() {
        $('#content').lightGallery({
            selector    : '.lightgallery',
            download    : false,
        });
        
        // top menu scroll
        function updateNavbar() {
            if ( $(window).scrollTop() > 20 ) {
                $('.navbar.fixed-top').addClass('scrolled');
            } else {
                $('.navbar.fixed-top').removeClass('scrolled');
            }
        }
        $(window).scroll(updateNavbar);
        updateNavbar();
    } );

    // navbar search form
    $('#navbar-menu').on('click', 'a[href="#search"]', function(e) {
        var that = $(this);
        $(this).closest('.navbar').find('.search-form-wrapper').removeClass('d-none').delay(50).fadeTo(200, 1);
    
        setTimeout(function() {
            $(that).closest('.navbar').find('#s').focus();
        }, 0);
    });

    $('#search').on('click', '.close-search', function(e) {
        $(this).closest('.search-form-wrapper').fadeTo( 200, 0, function() { $(this).addClass('d-none') } );
    });

    $('#navbar-collapse').on('hidden.bs.collapse', function() {
        $('#navbar-collapse .search-form-wrapper').fadeTo( 200, 0, function() { $(this).addClass('d-none') } );
    })

    // very lazy images
    var theLazyOne = $('.lazy').Lazy({
        enableThrottle: false,
        threshold: 600,
        scrollDirection: 'vertical',
        chainable: false,
        autoDestroy: false,
        effect: 'fadeIn',
        afterLoad: function(el) {
            el.addClass('loaded');
        },
    });
    
    // load more
    $('.load-more-container').on('click', '.load-more-btn', function(e) {
        e.preventDefault();

        var $btn        = $(this),
            $page       = $btn.data( 'page' ),
            $url        = $btn.data( 'base-url' ),
            $category   = $btn.data( 'category' ),
            $container  = $(this).closest( '.load-more-container' ),
            $items      = $container.find( '.load-more-items-wrapper' ),
            $data       = { page: $page };

            if ( $category && $category !== '' ) $data.categories = $category;

        $.ajax({
            url: $url,
            type: 'get',
            data: $data,
            beforeSend: function() {
                $container.addClass( 'loading' );
                $btn.attr( 'disabled', true );
            },
            success: function( response, status, request ) {            
                var $nextPage           = $page + 1;
                var $pageSeparatorId    = 'page-' + $page;
                var $currentScrollTop   = document.documentElement.scrollTop;

                // update load more button
                var totalPages = request.getResponseHeader( 'X-WP-TotalPages' );
                if ( totalPages && $nextPage >= totalPages ) {
                    $btn.fadeOut();
                } else {
                    $btn.data( 'page', $nextPage );
                    $btn.attr( 'href', $btn.attr( 'href' ).replace( $page, $nextPage ) );
                }
                
                // append
                $items.append( '<div id="' + $pageSeparatorId + '" class="virtual-page-separator"></div>' );
                $.each( response, function( index, value ) {
                    $html = $( value.preview );
                    $html.css({ opacity: 0 });
                    $appended = $items.append( $html );
                    $html.delay( index * 25 ).animate({ opacity: 1 });
                } );
                
                // lazy images
                theLazyOne.addItems( $items.find( '.lazy:not(.loaded)' ) );
                theLazyOne.update();

                // modify history
                var $nextUrl = history.state ? location.href.replace( history.state, $page ) : 'page/' + $page + '/';
                if ( history.state )
                    history.replaceState( $page, null, $nextUrl );
                else
                    history.pushState( $page, null, $nextUrl );

                // scroll
                $(document).scrollTop($currentScrollTop);
                $('html, body').animate({
                    scrollTop: $( '#' + $pageSeparatorId ).offset().top - 270,
                }, 700);

                // remove loading
                $container.removeClass( 'loading' );
                $btn.attr( 'disabled', false );
            },
            error: function ( xhr, ajaxOptions, thrownError ) {
                $btn.attr( 'disabled', false );
                $container.removeClass( 'loading' );
                console.log(thrownError);
            },
            timeout: 30000,
        });
    });

    // lists swiper
    var listsSwiperShouldResume = true;
    var listsSwiper = new Swiper('.swiper-lists', {
        lazy: true,
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        speed: 700,
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            autoplayStart: function () {
                listsSwiperShouldResume = true;
            },
        },
    });

    $('.swiper-container').on( 'click',  function() {
        listsSwiperShouldResume = false;
        listsSwiper.autoplay.stop();
    });

    $('.swiper-container').on( 'mouseenter', function() {
        listsSwiper.autoplay.stop();
    });

    $('.swiper-container').on( 'mouseleave', function() {
        if ( listsSwiperShouldResume ) listsSwiper.autoplay.start();
    });

    // Luxeat Insider bounce modal
    luxeatInsiderModal = ouibounce(false, {
        // aggressive      : true, // for testing purposes only!
        sitewide        : true,
        timer           : parseInt( li_popup_settings.exit_intent_detection_delay ),
        delay           : parseInt( li_popup_settings.exit_intent_detection_grace_period ),
        sensitivity     : parseInt( li_popup_settings.exit_intent_detection_sensitivity ),
        cookieExpire    : parseFloat( li_popup_settings.biscuit_expiration_base ),
        cookieName      : 'luxeat-insider-ei-modal',
        callback        : function() { $('#luxeat-insider-modal').modal('show'); }
    });

    $('#luxeat-insider-modal').on('click', '.already-a-subscriber', function(e) {
        luxeatInsiderModal.disable({
            cookieExpire: parseInt( li_popup_settings.biscuit_expiration_already_a_subscriber ),
        });
        $('#luxeat-insider-modal').modal('hide');
    });

    $('.newsletter-subscription-form').submit(function(e) {
        luxeatInsiderModal.disable({
            cookieExpire: parseInt( li_popup_settings.biscuit_expiration_after_subscription ),
        });
        $('#luxeat-insider-modal').modal('hide');
    });
    
    $(document).ready( function() {
        var watchBlogPostScrollTop = debounce(function() {
            var relatedScrollTop    = $('.section-related-posts').first().offset().top - $(window).scrollTop() - $(window).innerHeight();
            var relatedInViewport   = 0 > relatedScrollTop;
            var halfwayIn           = $('body').height() > $(window).innerHeight() * 3 && $(window).scrollTop() + $(window).innerHeight() / 2 > $('body').height() / 2;

            (relatedInViewport || halfwayIn) && luxeatInsiderModal.fire();
        }, 250);
        
        if (!luxeatInsiderModal.isDisabled() && $('body').hasClass('single-post')) {
            $(window).scroll(watchBlogPostScrollTop);
        }
    } );

})(jQuery);